import React, { useEffect, useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import PlantillaScreen from "../helpers/PlantillaScreen";
import { GetASD, GroupByPropCheck } from "../Finanzas/Actions/GetContainer";
import { capitalizePalabras } from "../../Helpers/CapitalizePalabras";

// Catálogo de plantillas/sección — mismo catálogo fijo que FiltroMensajeriaEnviada (listado
// mensajería original)
const PLANTILLAS_CATALOGO = [
    { id: "CT", nombre: "Cotizaciones" },
    { id: "GT", nombre: "Garantía Temprana" },
    { id: "GD", nombre: "Garantías Tardías" },
    { id: "CH", nombre: "Checklist" },
    { id: "MT", nombre: "Mantenimiento" },
    { id: "CV", nombre: "Cartera Vencida" },
    { id: "CP", nombre: "Cartera por Vencer" },
    { id: "PR", nombre: "Promoción de refacciones" },
];

// Botón + modal "Filtro" — mismo patrón/estructura que FiltroReporteClientesActualizados (CRM):
// PlantillaScreen con título/X roja, mostrado/ocultado alternando el display del contenedor por
// id, con los inputs propios de Indicadores (fechas, línea, plantilla, ADR/sucursal).
// El ADR se trae de GetASD (mismo endpoint que los reportes CRM) y se cruza por idsucursal contra
// el catálogo de sucursales de Mensajería para saber qué región le corresponde a cada una.
export const MensajeriaFiltroBoton = ({ filtros, setFiltros, sucursales, onAplicar }) => {
    const [openModal, setOpenModal] = useState(false);
    const [adr, setAdr] = useState([]);
    const [sucursalAdrMap, setSucursalAdrMap] = useState({});

    useEffect(() => {
        GetASD()
            .then((res) => {
                setAdr(GroupByPropCheck(res, ["idadr", "adr"], false));

                // Mapa idsucursal -> idadr, para saber a qué región pertenece cada sucursal de Mensajería
                const mapa = {};
                res.forEach((r) => { mapa[r.idsucursal] = r.idadr; });
                setSucursalAdrMap(mapa);
            })
            .catch((err) => console.log(err));
    }, []);

    const onOpenModal = () => {
        const container = document.getElementById("mjrFiltroIndicadores-modal");
        if (!container) return;
        if (openModal) {
            container.style.display = "flex";
            setOpenModal(false);
        } else {
            container.style.display = "none";
            setOpenModal(true);
        }
    };

    const toggleSucursal = (id) => {
        setFiltros((prev) => ({
            ...prev,
            sucursales: prev.sucursales.includes(id)
                ? prev.sucursales.filter((s) => s !== id)
                : [...prev.sucursales, id],
        }));
    };

    const onAdrChange = (e, index) => {
        const updated = [...adr];
        updated[index].checked = e.target.checked;
        setAdr(updated);

        const activos = updated.filter((a) => a.checked);
        const idsActivos = activos.map((a) => String(a.idadr));

        if (idsActivos.length === 0) {
            setFiltros((prev) => ({ ...prev, adr: [], sucursales: [] }));
            return;
        }
        const sucursalesDeRegion = sucursales
            .filter((s) => idsActivos.includes(String(sucursalAdrMap[s.id])))
            .map((s) => s.id);
        setFiltros((prev) => ({ ...prev, adr: idsActivos, sucursales: sucursalesDeRegion }));
    };

    const handleCargar = () => {
        onOpenModal();
        onAplicar?.();
    };

    return (
        <div className="mjr-filtro">
            <button type="button" className="mjr-filtro-btn" onClick={onOpenModal}>
                <FilterAltIcon /> Filtrar
            </button>

            <div className="mjr-filtro-modal" id="mjrFiltroIndicadores-modal">
                <PlantillaScreen titulo="Filtro" className_main={1} className="mjr-filtro-modal-plantilla">
                    <div className="mjr-filtro-modal-close" onClick={onOpenModal}>
                        X
                    </div>

                    <div className="mjr-filtro-modal-body">
                        <div className="mjr-filtro-modal-filtros">
                            <div className="mjr-filtro-tiempo">
                                <div className="mjr-filtro-group">
                                    <label>Fecha inicio</label>
                                    <input
                                        type="date"
                                        className="mjr-filtro-date-input"
                                        value={filtros.fechaInicio}
                                        onChange={(e) => setFiltros((prev) => ({ ...prev, fechaInicio: e.target.value }))}
                                    />
                                </div>

                                <div className="mjr-filtro-group">
                                    <label>Fecha fin</label>
                                    <input
                                        type="date"
                                        className="mjr-filtro-date-input"
                                        value={filtros.fechaFin}
                                        onChange={(e) => setFiltros((prev) => ({ ...prev, fechaFin: e.target.value }))}
                                    />
                                </div>

                                <div className="mjr-filtro-group">
                                    <label>Línea</label>
                                    <select
                                        className="mjr-filtro-select"
                                        value={filtros.linea || "Consolidado"}
                                        onChange={(e) => setFiltros((prev) => ({ ...prev, linea: e.target.value }))}
                                    >
                                        <option value="Consolidado">Consolidado</option>
                                        <option value="Posventa">Posventa</option>
                                        <option value="Cobranza">Cobranza</option>
                                    </select>
                                </div>

                                <div className="mjr-filtro-group">
                                    <label>Plantilla</label>
                                    <select
                                        className="mjr-filtro-select"
                                        value={filtros.plantilla || ""}
                                        onChange={(e) => setFiltros((prev) => ({ ...prev, plantilla: e.target.value }))}
                                    >
                                        <option value="">Todas</option>
                                        {PLANTILLAS_CATALOGO.map((p) => (
                                            <option key={p.id} value={p.id}>{p.nombre}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="mjr-filtro-btn-cargar" onClick={handleCargar}>
                                    Cargar
                                </div>
                            </div>

                            <div className="mjr-filtro-adr">
                                <div className="mjr-filtro-title">Región</div>
                                {adr.map((item, index) => (
                                    <div key={item.idadr} className="mjr-chk-groups">
                                        <input
                                            type="checkbox"
                                            checked={item.checked}
                                            onChange={(e) => onAdrChange(e, index)}
                                        />
                                        <label>{capitalizePalabras(item.adr)}</label>
                                    </div>
                                ))}
                            </div>

                            <div className="mjr-filtro-sucursal">
                                <div className="mjr-filtro-title">Sucursal</div>
                                {sucursales.map((s) => (
                                    <div key={s.id} className="mjr-chk-groups">
                                        <input
                                            type="checkbox"
                                            checked={filtros.sucursales.includes(s.id)}
                                            onChange={() => toggleSucursal(s.id)}
                                        />
                                        <label>{s.nombre}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </PlantillaScreen>
            </div>
        </div>
    );
};
